import { translate } from 'translations'

const Routes = {
  home:             '/',
  page:             '/:page',
  chapters:         `/${translate('slug.chapters')}`,
  chapter:          `/${translate('slug.chapters')}/:chapter`,
  aspect:           `/${translate('slug.chapters')}/:chapter/:aspect`,
  endtest:          `/${translate('slug.endtest')}`,
  endtestTest:      `/${translate('slug.endtest')}/${translate('slug.endtestTest')}`,
  endtestPassed:    `/${translate('slug.endtest')}/${translate('slug.endtestPassed')}`,
  endtestNotPassed: `/${translate('slug.endtest')}/${translate('slug.endtestNotPassed')}`,
}

Routes.path = name => {
  return Routes[name]
}

Routes.to = (name, params) => {
  let url = Routes.path(name)
  if(params) Object.entries(params).map(prop => url = url.replace(`:${prop[0]}`, prop[1]))

  return url
}

export default {
  to: Routes.to,
  path: Routes.path
}


// WEBPACK FOOTER //
// ./src/routes.js